// extracted by mini-css-extract-plugin
export default {"lightDark":"JournalInfo_lightDark__5jQiE","customLink":"JournalInfo_customLink__3Zu1d","secondaryColor":"JournalInfo_secondaryColor__a4rzp"};